import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DefaultApp, SupportedApp } from "config/config";

interface AppState {
    selectedApp: SupportedApp;
}

const initialState: AppState = {
    selectedApp: DefaultApp,
};

export const AppSliceName = "app";

const appSlice = createSlice({
    name: AppSliceName,
    initialState,
    reducers: {
        setSelectedApp(state, action: PayloadAction<SupportedApp>) {
            // eslint-disable-next-line no-param-reassign
            state.selectedApp = action.payload;
        },
    },
    selectors: {
        selectedAppSelector: (state) => {
            // only data is persisted, need to add necessary methods
            // manually on restore (maybe there's a better way than this though)

            // eslint-disable-next-line no-param-reassign
            state.selectedApp.equals = SupportedApp.prototype.equals;
            return state.selectedApp;
        },
    },
});

export const { setSelectedApp } = appSlice.actions;
export const { selectedAppSelector } = appSlice.selectors;
export default appSlice.reducer;
